import { z } from 'zod';
import { createContext } from 'react';

/**
 * Attribution for the PACU analytics tab: group rows by the patient's surgeon
 * (default) or the procedure's anesthesiologist. Values match the backend
 * UtilizationGroupBy GraphQL enum.
 */
export const PacuGroupBy = z.enum(['SURGEON', 'ANESTHESIOLOGIST']);

export type PacuGroupBy = z.infer<typeof PacuGroupBy>;

export const PacuGroupByContext = createContext<PacuGroupBy>('SURGEON');
